var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitroen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.894,
    height: 45.869,
    viewBox: "0 0 52.894 45.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ccc}.cls-2{fill:#a6a6a6}.cls-3{fill:#8c8c8c}.cls-4{fill:#fcee21}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "citroen",
    transform: "translate(0 -34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    d: "M52.888 57.91l-.3 2.883a.982.982 0 0 1-1.628.635 67.097 67.097 0 0 0-.74-.629C38.37 50.811 27.868 47.182 26.579 46.76a.425.425 0 0 0-.264 0c-1.315.429-12.229 4.2-24.379 14.668a.985.985 0 0 1-1.628-.635L0 57.91a.972.972 0 0 1 .188-.689c1.875-2.484 14.918-19.382 25.9-23.162a1.08 1.08 0 0 1 .7 0c9.05 3.117 19.515 15.157 23.957 20.676a100.134 100.134 0 0 1 1.944 2.487.972.972 0 0 1 .199.688z",
    className: "cls-1",
    "data-name": "Trazado 361"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    d: "M55.258 144.263l-.062.256a.988.988 0 0 1-1.567.379c-12.15-10.468-23.068-14.239-24.379-14.668a.424.424 0 0 0-.263 0c-1.311.429-12.229 4.2-24.379 14.668a.985.985 0 0 1-1.628-.635s18.689-17.177 26.139-17.177 26.139 17.177 26.139 17.177z",
    className: "cls-2",
    "data-name": "Trazado 362",
    transform: "translate(-2.673 -83.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    d: "M488.771 237.882l-.3 2.883a.982.982 0 0 1-1.628.635q-.37-.319-.74-.629a31.234 31.234 0 0 0 .537-6.064 100.134 100.134 0 0 1 1.944 2.487.971.971 0 0 1 .187.688z",
    className: "cls-3",
    "data-name": "Trazado 363",
    transform: "translate(-435.883 -179.972)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    d: "M247.329 238.339h-2.66v-2.657h2.661v2.657z",
    className: "cls-4",
    "data-name": "Trazado 364",
    transform: "translate(-219.393 -180.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    d: "M156.42 114.049a.106.106 0 0 0 .082.2 33.749 33.749 0 0 1 10.152-1.923 32.651 32.651 0 0 1 10.021 1.916.106.106 0 0 0 .084-.195c-2.351-1.206-7.084-3.422-10.105-3.422s-7.846 2.22-10.234 3.424z",
    className: "cls-3",
    "data-name": "Trazado 365",
    transform: "translate(-140.208 -68.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    d: "M52.89 234.055l-.3 2.883a.982.982 0 0 1-1.628.635q-.37-.319-.74-.629c-11.848-9.989-22.35-13.617-23.639-14.039a.425.425 0 0 0-.264 0c-1.312.429-12.229 4.2-24.379 14.668a.985.985 0 0 1-1.628-.635l-.3-2.883a.972.972 0 0 1 .188-.689c1.874-2.484 14.918-19.383 25.9-23.162a1.08 1.08 0 0 1 .7 0c9.05 3.117 19.515 15.157 23.957 20.676a100.134 100.134 0 0 1 1.944 2.487.972.972 0 0 1 .189.688z",
    className: "cls-1",
    "data-name": "Trazado 366",
    transform: "translate(-.002 -157.947)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    d: "M55.258 320.408l-.062.256a.988.988 0 0 1-1.567.379C41.48 310.574 30.562 306.8 29.251 306.374a.423.423 0 0 0-.263 0c-1.311.429-12.229 4.2-24.379 14.668a.985.985 0 0 1-1.628-.635S21.67 303.23 29.12 303.23s26.138 17.178 26.138 17.178z",
    className: "cls-2",
    "data-name": "Trazado 367",
    transform: "translate(-2.673 -241.417)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    transform: "translate(16.153 60.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_368",
    d: "M488.771 414.027l-.3 2.883a.982.982 0 0 1-1.628.635 67.097 67.097 0 0 0-.74-.629 31.233 31.233 0 0 0 .537-6.064 100.134 100.134 0 0 1 1.944 2.487.971.971 0 0 1 .187.688z",
    className: "cls-3",
    "data-name": "Trazado 368",
    transform: "translate(-452.036 -398.033)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    d: "M156.42 290.194a.106.106 0 0 0 .082.2 33.75 33.75 0 0 1 10.152-1.923 32.65 32.65 0 0 1 10.021 1.916.106.106 0 0 0 .084-.195c-2.351-1.206-7.084-3.422-10.105-3.422s-7.846 2.22-10.234 3.424z",
    className: "cls-3",
    "data-name": "Trazado 369",
    transform: "translate(-156.361 -286.766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitroen);
export default __webpack_public_path__ + "static/media/citroen.8fe01731c11b7c4b1dec73e1cc26c930.svg";
export { ForwardRef as ReactComponent };